<ng-container class="panel__heading--left" [ngSwitch]="startDateType">
    <h3>
        <ng-container *ngSwitchCase="startDateTypeEnum.Set">Ingangsdatum verzekering opgeven</ng-container>
        <ng-container *ngSwitchDefault>Ingangsdatum wijzigen</ng-container>
    </h3>
</ng-container>
<p>Geef hieronder de gewenste ingangsdatum van uw verzekering op.</p>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <wuc-form-field>
        <wuc-form-field-label>Ingangsdatum</wuc-form-field-label>
        <wuc-input-date-picker
            formControlName="startDate"
            [selectPastDates]="false"
            [selectToday]="false"
        ></wuc-input-date-picker>
        <wuc-input-alert *ngIf="startDate.touched && startDate.hasError('required')">
            Vul uw ingangsdatum in.
        </wuc-input-alert>
    </wuc-form-field>
    <wuc-rack [columnsDesktop]="1" gridGap="medium">
        <ins-insurance-notification [errorNotifications]="errorNotifications"></ins-insurance-notification>
        <span>
            <wuc-button [isSubmitButton]="true" [ngSwitch]="startDateType" class="pull-right">
                <ng-container *ngSwitchCase="startDateTypeEnum.Set">
                    Ja, dit wordt 'm
                </ng-container>
                <ng-container *ngSwitchDefault>
                    Wijzigen
                </ng-container>
            </wuc-button>
        </span>
    </wuc-rack>
</form>
